/* eslint-disable no-underscore-dangle */
import axios from "axios"
/**
 * _defaultDomain：默认主域名
 * _neutralDomain：中性主域名
 */

const _defaultDomain = "icsoc.net"
const _neutralDomain = "ctiplus.com"
/**
 * 在window上初始化当前对应的主域
 */
const getDomain = () => {
  let origin = window.location.hostname || ""
  window._Domain = _defaultDomain

  if (process.env.JS_ENV !== "onpremise") {
    window._Domain = _defaultDomain
    //如何URL中包含目标域名，则最终域名使用目标域名，否则使用
    if (new RegExp(_neutralDomain).test(origin)) {
      window._Domain = _neutralDomain
    }
  } else {
    window._Domain = ""
  }
}

const getDomainConfig = (callBack) => {
  const url = "/domain.json"
  getDomain()
  axios
    .get(url)
    .then((res) => {
      const { status, data } = res
      // eslint-disable-next-line eqeqeq
      if (status == 200 && data) {
        let dataStr = JSON.stringify(data)
        dataStr = dataStr.replace(/\{__DOMAIN__\}/g, window._Domain)

        const config = JSON.parse(dataStr)

        const reg = /^https?:\/\//

        Object.keys(config).forEach((item) => {
          const val = config[item]
          config[item] = reg.test(val)
            ? val
            : `${window.location.protocol}${val}`
        })
        window.__config = config
      }

      if (callBack) callBack()
    })
    .catch((err) => {
      console.log('getDomainConfig --->err', err)
      if (callBack) callBack()
    })
}

export default getDomainConfig
